import { useEffect, useState } from "react";
import { clearToken, getToken, usersApi, type User } from "../api/client";
import { todayLocalDate } from "../lib/date";
import { getPreviewUser, isTodayPreviewMode } from "../lib/preview";

export function useAuth(): {
  user: User | null;
  loading: boolean;
  logout: () => void;
  refreshUser: (date?: string) => Promise<User | null>;
} {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = async (date: string = todayLocalDate()): Promise<User | null> => {
    if (isTodayPreviewMode()) {
      const previewUser = getPreviewUser();
      setUser(previewUser);
      return previewUser;
    }

    const token = getToken();
    if (!token) {
      setUser(null);
      return null;
    }
    try {
      const nextUser = await usersApi.me(date);
      setUser(nextUser);
      return nextUser;
    } catch {
      setUser(null);
      return null;
    }
  };

  useEffect(() => {
    refreshUser().finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    user,
    loading,
    refreshUser,
    logout: () => {
      clearToken();
      location.replace("/login");
    },
  };
}
